import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import EditorialMarquee from "@/components/EditorialMarquee";
import Services from "@/components/Services";
import NfcShowcase from "@/components/NfcShowcase";
import Process from "@/components/Process";
import Portfolio from "@/components/Portfolio";
import ForVenues from "@/components/ForVenues";
import CtaSection from "@/components/CtaSection";
import ContactForm from "@/components/ContactForm";
import Footer from "@/components/Footer";
import Admin from "@/pages/Admin";
import MenuApp from "@/menu/MenuApp";
import PrivacyPage from "@/pages/PrivacyPage";
import CookiePage from "@/pages/CookiePage";

const Home = () => (
  <main data-testid="home-page" className="relative">
    <Navbar />
    <Hero />
    <EditorialMarquee />
    <Services />
    <NfcShowcase />
    <Process />
    <Portfolio />
    <ForVenues />
    <CtaSection />
    <ContactForm />
    <Footer />
  </main>
);

function App() {
  useEffect(() => {
    document.documentElement.style.setProperty("--marble-url", "url('/assets/marble.jpg')");
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true, anchors: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <div className="noise-overlay" aria-hidden="true" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/cookie-policy" element={<CookiePage />} />
          <Route path="/menu/*" element={<MenuApp />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
